export default [
  {
    text: 'Name',
    value: 'name',
    order: 0,
    sortable: true,
    hidable: false,
    hidden: false,
  },

  {
    text: 'Translation Status',
    value: 'translationStatus',
    order: 1,
    sortable: false,
    hidable: true,
    hidden: false,
    width: '220px',
  },

  {
    text: 'Elevation',
    value: 'bottomElevation',
    order: 2,
    sortable: true,
    hidable: true,
    hidden: false,
  },

  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
    width: '92px',
  },
];
